import axios from 'axios';

export const authService = {
    /** Assessments */

    getAssessmentsService: (clientId, params) => axios.get(`/assessment/${clientId}`, { auth: true, params: { ...params } }),

    getAssessmentByIdService: (assessmentId) => axios.get(`/assessment/byId/${assessmentId}`, { auth: true }),

    createAssessmentService: (clientId) =>
        axios.get(`/assessment/signin/vbMapp`, {
            auth: true,
            params: { clientId: clientId },
        }),

    saveAssessmentsService: (clientId) => axios.patch(`/assessment/${clientId}`, {}, { auth: true }),

    editAssessmentService: (id, body) => axios.post(`/goal/assessment/${id}`, body, { auth: true }),

    deleteAssessmentService: (id) => axios.delete(`/goal/assessment/${id}`, { auth: true }),

    /** End */
};
